"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const _1 = require(".");
function default_1({ isSecondPayment, setPaymentDetail, onError, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const orderId = (0, functions_1.getNumberFromUrl)(window.location.pathname);
        const formData = new FormData();
        formData.append('order_id', String(orderId));
        formData.append('status', isSecondPayment ? '2' : '1');
        yield (0, api_1.postFormData)('/credit/change_payment/', formData)
            .then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.status === 200) {
                yield (0, _1.refetchPaymentDetail)({ setPaymentDetail });
                (0, functions_1.showToastMessage)({ message: i18next_1.default.t('결제수단이 초기화되었어요') });
            }
            else
                throw new Error();
        }))
            .catch(() => {
            onError();
            (0, functions_1.showToastMessage)({ message: i18next_1.default.t('새로고침 후 다시 시도해주세요') });
        });
    });
}
exports.default = default_1;
